<template>
  <!-- Tab panes-->
  <div class="tab-content">
    <register-form v-show="isRegActive" />
    <login-form v-show="!isRegActive" />
  </div>
</template>

<script>
import RegisterForm from './RegisterForm'
import LoginForm from './LoginForm'

export default {
  name: 'TabPanes',
  components: { RegisterForm, LoginForm },
  props: {
    isRegActive: {
      type: Boolean
    }
  },
  computed: {},
  methods: {}
}
</script>
